export default __webpack_public_path__ + "static/media/EC.8e7c5fe8.svg";